import { render, staticRenderFns } from "./CurrencySimulation2.vue?vue&type=template&id=8f5fa2bc&"
import script from "./CurrencySimulation2.vue?vue&type=script&lang=ts&"
export * from "./CurrencySimulation2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports